import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/dashboard/page.tsx");
